module.exports = __webpack_public_path__ + "img/50_28.5f1fe9bf.png";